import { GetListResponse, WithdrawHistory } from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestParams } from "@core/services/http/http.type";

class _WithdrawHistoryService {
  public getTransferHistory(requestParams?: RequestParams) {
    return HttpService.get<GetListResponse<WithdrawHistory>>(
      "/admin/api/v2/transfer-histories-author",
      {
        queryParams: { ...requestParams },
      }
    );
  }
}

const WithdrawHistoryService = new _WithdrawHistoryService();

export default WithdrawHistoryService;
